import {createStore, applyMiddleware, combineReducers} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension'
import thunk from 'redux-thunk'

import Data from './routers/data'
import Settings from './routers/settings'
import Messages from './routers/messages'

const reducer = combineReducers({
	data: Data,
	settings: Settings,
	messages: Messages
})

const compose = composeWithDevTools({trace: true, traceLimit: 25})
export default createStore(
	reducer,
	compose(
		applyMiddleware(thunk)
	)
)



// WEBPACK FOOTER //
// ./src/shared/store.js